import React, { useEffect, useState } from 'react'
import Header from './Layouts/Header'
import Sidebar from './Layouts/Sidebar'
import { SERVER_URL } from '../Config';
import axios from 'axios';
import toast from 'react-hot-toast';

const networkIcons = {
    TRON: 'https://cdn3d.iconscout.com/3d/premium/thumb/tron-trx-badge-3d-illustration-download-in-png-blend-fbx-gltf-file-formats--cryptocurrency-symbol-crypto-badges-vol-1-pack-science-technology-illustrations-4414723.png?f=webp',
    BNB: 'https://cdn3d.iconscout.com/3d/premium/thumb/binance-crypto-3d-illustration-download-in-png-blend-fbx-gltf-file-formats--symbol-sign-logo-coin-glossy-pack-science-technology-illustrations-3591027.png?f=webp',
    ETH: '/assets/img/icon/watch-icon-07.svg',
    POL: 'https://cryptologos.cc/logos/polygon-matic-logo.png',
    SOL: 'https://cdn-icons-png.flaticon.com/512/6001/6001527.png'
};

function CoinTrans() {
    const [transactions, setTransactions] = useState([]);
    const [searchTerm, setSearchTerm] = useState("");

    useEffect(() => {
        const fetchTransactions = async () => {
            try {
                const response = await axios.get(`${SERVER_URL}/api/admin/FetchWalletTransactions`);
                console.log("Transactions Data:", response.data);

                if (response.data.status && response.data.transactions.length > 0) {
                    setTransactions(response.data.transactions.filter(type => type.transfer_type == 'coin'));
                }else{
                    setTransactions([]); 
                }
            } catch (error) {
                console.error("Error fetching transactions:", error);
                setTransactions([]);

            }
        };

        fetchTransactions();
    }, []);


    function formatDate(dateString) {
        const date = new Date(dateString);

        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');

        const hours = String(date.getHours()).padStart(2, '0');
        const minutes = String(date.getMinutes()).padStart(2, '0');
        const seconds = String(date.getSeconds()).padStart(2, '0');

        return `${year} -${month} -${day} ${hours}:${minutes}:${seconds}`;
    }
    const copyToClipboard = (text) => {
        navigator.clipboard.writeText(text).then(() => {
            toast.success("Copied to clipboard!"); 
        });
    };

    const shortenHash = (hash) => {
        return hash ? `${hash.slice(0, 6)}...${hash.slice(-6)}` : "";
      };

      const filteredTransactions = (transactions || []).filter((tx) => {
        if (!tx) return false; 
    
        if (!tx.from_wallet || !tx.to_wallet) return false;  
    
        return (
            tx.from_wallet.toLowerCase().includes(searchTerm.trim().toLowerCase()) ||
            tx.to_wallet.toLowerCase().includes(searchTerm.trim().toLowerCase())
        );
    });
    
    

    
    const getExplorerLink = (network, hash) => {
        const explorers = {
          BNB: `https://bscscan.com/tx/${hash}`,
          ETH: `https://sepolia.etherscan.io/tx/${hash}`,
          POL: `https://amoy.polygonscan.com/tx/${hash}`,
          TRON: `https://nile.tronscan.org/#/transaction/${hash}`,
          SOL:`https://solscan.io/tx/${hash}`
        };
    
        return explorers[network] || "#"; 
      };

    return (
        <div>
            <>
                <Header />
                <Sidebar />
                <div className="page-wrapper bg-wrapper">
                    <div className="content">
                        <div className="row">
                            <div className="col-sm-12">
                                <div className="transaction-grp">
                                    <div className="row">
                                        <div className="col-xl-3 col-md-6">
                                            <div className="transaction-record blue-view">
                                                <h2>{transactions.length}</h2>
                                                <p>Total Coin Transactions</p>
                                            </div>
                                        </div>
                                        
                                    </div>
                                </div>
                                <div className="recent-buy comman-head">
                                    <h3>Recent Coin transactions</h3>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="buy-form-crypto mb-0">
                                                <input
                                                    type="text"
                                                    placeholder="Search By Wallet Address..."
                                                    value={searchTerm}
                                                    onChange={(e) => setSearchTerm(e.target.value)}
                                                    className="form-control mb-3"
                                                />
                                                <div className="table-responsive">
                                                    <table className="datatable table  custom-table">
                                                        <thead>
                                                            <tr>
                                                                <th>ID No</th>
                                                                <th>Currency type</th>
                                                                <th style={{ minWidth: 110 }}>User Id</th>
                                                                <th style={{ minWidth: 110 }}>Amount</th>
                                                                <th style={{ minWidth: 110 }}>From Address</th>
                                                                <th style={{ minWidth: 110 }}>To Address</th>
                                                               
                                                                <th style={{ minWidth: 110 }}>Hash</th>
                                                                <th style={{ minWidth: 110 }}>Time</th>

                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {filteredTransactions.length > 0 ? (
                                                                filteredTransactions.map((txn, index) => (
                                                                    <tr key={txn.hash}>
                                                                        <td>{index + 1}</td>
                                                                        <td>
                                                                            <img
                                                                                src={networkIcons[txn.network === "EVM" ? "ETH" : txn.network] || '/assets/img/icon/dash-icon-02.svg'}
                                                                                alt={txn.network === "EVM" ? "ETH" : txn.network}
                                                                                className="me-2"
                                                                                width="24"
                                                                                height="24"
                                                                            />
                                                                            {txn.network === "EVM" ? "ETH" : txn.network}
                                                                        </td>

                                                                        <td onClick={() => copyToClipboard(txn.user_id)} className="cursor-pointer">{txn.user_id}</td>
                                                                        <td>{txn.amount}</td>
                                                                        <td onClick={() => copyToClipboard(txn.from_wallet)} className="cursor-pointer">{shortenHash(txn.from_wallet)}</td>
                                                                        <td onClick={() => copyToClipboard(txn.to_wallet)} className="cursor-pointer">{shortenHash(txn.to_wallet)}</td>
                                                                       
                                                                        <td>
                                                                            <a
                                                                                href={getExplorerLink(txn.network, txn.txnHash)}
                                                                                target="_blank"
                                                                                rel="noopener noreferrer"
                                                                            >
                                                                                {shortenHash(txn.txnHash)}
                                                                            </a>
                                                                        </td>
                                                                        
                                                                        <td>{formatDate(txn.created_at)}</td>
                                                                    </tr>
                                                                ))
                                                            ) : (
                                                                <tr>
                                                                    <td colSpan="8" className="text-center">
                                                                        No transactions found.
                                                                    </td>
                                                                </tr>
                                                            )}
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* <div className="notification-box">
                    <div className="msg-sidebar notifications msg-noti">
                        <div className="topnav-dropdown-header">
                            <span>Messages</span>
                        </div>
                        <div className="drop-scroll msg-list-scroll" id="msg_list">
                            <ul className="list-box">
                                <li>
                                    <a href="chat.html">
                                        <div className="list-item">
                                            <div className="list-left">
                                                <span className="avatar">R</span>
                                            </div>
                                            <div className="list-body">
                                                <span className="message-author">Richard Miles </span>
                                                <span className="message-time">12:28 AM</span>
                                                <div className="clearfix" />
                                                <span className="message-content">
                                                    Lorem ipsum dolor sit amet, consectetur adipiscing
                                                </span>
                                            </div>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a href="chat.html">
                                        <div className="list-item new-message">
                                            <div className="list-left">
                                                <span className="avatar">J</span>
                                            </div>
                                            <div className="list-body">
                                                <span className="message-author">John Doe</span>
                                                <span className="message-time">1 Aug</span>
                                                <div className="clearfix" />
                                                <span className="message-content">
                                                    Lorem ipsum dolor sit amet, consectetur adipiscing
                                                </span>
                                            </div>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a href="chat.html">
                                        <div className="list-item">
                                            <div className="list-left">
                                                <span className="avatar">T</span>
                                            </div>
                                            <div className="list-body">
                                                <span className="message-author"> Tarah Shropshire </span>
                                                <span className="message-time">12:28 AM</span>
                                                <div className="clearfix" />
                                                <span className="message-content">
                                                    Lorem ipsum dolor sit amet, consectetur adipiscing
                                                </span>
                                            </div>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a href="chat.html">
                                        <div className="list-item">
                                            <div className="list-left">
                                                <span className="avatar">M</span>
                                            </div>
                                            <div className="list-body">
                                                <span className="message-author">Mike Litorus</span>
                                                <span className="message-time">12:28 AM</span>
                                                <div className="clearfix" />
                                                <span className="message-content">
                                                    Lorem ipsum dolor sit amet, consectetur adipiscing
                                                </span>
                                            </div>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a href="chat.html">
                                        <div className="list-item">
                                            <div className="list-left">
                                                <span className="avatar">C</span>
                                            </div>
                                            <div className="list-body">
                                                <span className="message-author"> Catherine Manseau </span>
                                                <span className="message-time">12:28 AM</span>
                                                <div className="clearfix" />
                                                <span className="message-content">
                                                    Lorem ipsum dolor sit amet, consectetur adipiscing
                                                </span>
                                            </div>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a href="chat.html">
                                        <div className="list-item">
                                            <div className="list-left">
                                                <span className="avatar">D</span>
                                            </div>
                                            <div className="list-body">
                                                <span className="message-author"> Domenic Houston </span>
                                                <span className="message-time">12:28 AM</span>
                                                <div className="clearfix" />
                                                <span className="message-content">
                                                    Lorem ipsum dolor sit amet, consectetur adipiscing
                                                </span>
                                            </div>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a href="chat.html">
                                        <div className="list-item">
                                            <div className="list-left">
                                                <span className="avatar">B</span>
                                            </div>
                                            <div className="list-body">
                                                <span className="message-author"> Buster Wigton </span>
                                                <span className="message-time">12:28 AM</span>
                                                <div className="clearfix" />
                                                <span className="message-content">
                                                    Lorem ipsum dolor sit amet, consectetur adipiscing
                                                </span>
                                            </div>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a href="chat.html">
                                        <div className="list-item">
                                            <div className="list-left">
                                                <span className="avatar">R</span>
                                            </div>
                                            <div className="list-body">
                                                <span className="message-author"> Rolland Webber </span>
                                                <span className="message-time">12:28 AM</span>
                                                <div className="clearfix" />
                                                <span className="message-content">
                                                    Lorem ipsum dolor sit amet, consectetur adipiscing
                                                </span>
                                            </div>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a href="chat.html">
                                        <div className="list-item">
                                            <div className="list-left">
                                                <span className="avatar">C</span>
                                            </div>
                                            <div className="list-body">
                                                <span className="message-author"> Claire Mapes </span>
                                                <span className="message-time">12:28 AM</span>
                                                <div className="clearfix" />
                                                <span className="message-content">
                                                    Lorem ipsum dolor sit amet, consectetur adipiscing
                                                </span>
                                            </div>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a href="chat.html">
                                        <div className="list-item">
                                            <div className="list-left">
                                                <span className="avatar">M</span>
                                            </div>
                                            <div className="list-body">
                                                <span className="message-author">Melita Faucher</span>
                                                <span className="message-time">12:28 AM</span>
                                                <div className="clearfix" />
                                                <span className="message-content">
                                                    Lorem ipsum dolor sit amet, consectetur adipiscing
                                                </span>
                                            </div>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a href="chat.html">
                                        <div className="list-item">
                                            <div className="list-left">
                                                <span className="avatar">J</span>
                                            </div>
                                            <div className="list-body">
                                                <span className="message-author">Jeffery Lalor</span>
                                                <span className="message-time">12:28 AM</span>
                                                <div className="clearfix" />
                                                <span className="message-content">
                                                    Lorem ipsum dolor sit amet, consectetur adipiscing
                                                </span>
                                            </div>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a href="chat.html">
                                        <div className="list-item">
                                            <div className="list-left">
                                                <span className="avatar">L</span>
                                            </div>
                                            <div className="list-body">
                                                <span className="message-author">Loren Gatlin</span>
                                                <span className="message-time">12:28 AM</span>
                                                <div className="clearfix" />
                                                <span className="message-content">
                                                    Lorem ipsum dolor sit amet, consectetur adipiscing
                                                </span>
                                            </div>
                                        </div>
                                    </a>
                                </li>
                                <li>
                                    <a href="chat.html">
                                        <div className="list-item">
                                            <div className="list-left">
                                                <span className="avatar">T</span>
                                            </div>
                                            <div className="list-body">
                                                <span className="message-author">Tarah Shropshire</span>
                                                <span className="message-time">12:28 AM</span>
                                                <div className="clearfix" />
                                                <span className="message-content">
                                                    Lorem ipsum dolor sit amet, consectetur adipiscing
                                                </span>
                                            </div>
                                        </div>
                                    </a>
                                </li>
                            </ul>
                        </div>
                        <div className="topnav-dropdown-footer">
                            <a href="chat.html">See all messages</a>
                        </div>
                    </div>
                </div> */}
            </>

        </div>
    )
}

export default CoinTrans
